
import { Card, CardContent } from "@/components/ui/card";

interface ItemsTotalProps {
  totalAmount: number;
}

export const ItemsTotal = ({ totalAmount }: ItemsTotalProps) => {
  return (
    <Card>
      <CardContent className="pt-6">
        <div className="flex justify-between items-center text-lg font-semibold">
          <span>Sub Total:</span>
          <span>Br {totalAmount.toFixed(2)}</span>
        </div>
      </CardContent>
    </Card>
  );
};
